<template>
    <div>
        <headline>
            Buchungen
            <template #more>
                <monthspicker @date="load" :date="current" class="mr-2"></monthspicker>
                <button-secondary @click="download">
                    <template slot="icon"><i class="fa fa-download"></i></template>
                    Daten exportieren
                </button-secondary>
            </template>
        </headline>

        <loading v-show="loading"></loading>

        <div class="" v-show="!loading">
            <div>

                <accordion>
                    <accordion-item v-for="(foo, day) in users" :key="day" :id="day">
                        <template v-slot:header>
                            <span :class="{'text-primary': asDay(day) === asDay(today) }">{{ asDay(day) }}</span>
                            <span class="font-bold">{{
                                    users[day].length + (schedules[day] ? schedules[day].length : 0)
                                }} Buchungen</span>
                        </template>

                        <tailwind-table :header="['User', 'Schreibtisch', 'Zeit','']"
                                        v-show="users[day] && users[day].length > 0" class="mb-4">
                            <tr v-for="(item, i) in users[day]" :class="{'bg-gray-50': i%2}">
                                <td class="px-6 py-3">
                                    {{ item.user.first_name }} {{ item.user.name }}
                                </td>
                                <td class="px-6 py-3">
                                    <floor-item :item="item.user.desk?.floor"></floor-item>
                                    <desk-item v-if="item.user.desk" :item="item.user.desk"></desk-item>
                                </td>
                                <td class="px-6 py-3">
                                    <span v-if="!item.schedule">0 - 24</span>
                                    <span v-if="item.schedule">Freigegeben: {{
                                            item.schedule.begin
                                        }} - {{ item.schedule.end }}</span>
                                </td>
                                <td>
                                    <booking-release :userId="item.user.id" :day="day"
                                                     @reload="load()"></booking-release>
                                </td>
                            </tr>
                        </tailwind-table>
                        <tailwind-table :header="['User', 'Schreibtisch', 'Zeit', 'gebucht von','Check-In Zeit','']"
                                        v-show="schedules[day] && schedules[day].length > 0">
                            <tr v-for="(schedule, i) in schedules[day]" :class="{'bg-gray-50': i%2}"
                                v-show="!schedule.is_owner_schedule">
                                <td class="px-6 py-3">
                                    <span v-if="schedule.user">{{ schedule.user.first_name }} {{
                                            schedule.user.name
                                        }}</span>
                                    <span v-show="schedule.user_id && !schedule.user">gelöschter User</span>
                                    <span v-if="!schedule.user_id && schedule.reservation && schedule.reservation">Gästebuchung: &quot;{{
                                            schedule.reservation.comment
                                        }}&quot;</span>
                                </td>
                                <td class="px-6 py-3">
                                    <floor-item :item="schedule.desk.floor"></floor-item>
                                    <desk-item :item="schedule.desk"></desk-item>
                                </td>
                                <td class="px-6 py-3">
                                    {{ schedule.begin }} - {{ schedule.end }}
                                </td>
                                <td class="px-6 py-3">
                                    {{ schedule.created_by?.first_name }} {{ schedule.created_by?.name }}
                                </td>
                                <td class="px-6 py-3">
                                    {{ schedule.check_in_time ? schedule.check_in_time.slice(11, 16) : '-' }}
                                </td>
                                <td class="px-2 py-3">
                                    <confirm-dialog @confirmed="remove(schedule)" @canceled="remove(schedule,true)">
                                        <template v-slot:header>Buchung löschen</template>
                                        <template v-slot:question>
                                            <span v-show="isSameDay(schedule)">
                                              Soll die Buchung von
                                              <span class="font-bold">{{ schedule.desk.name }}</span>
                                              wirklich gelöscht werden?
                                            </span>
                                            <span v-show="!isSameDay(schedule)"> Die ausgewählte Buchung für den
                                            <span class="font-bold">{{ day | date }}</span> ist Teil einer Serienbuchung. Möchten Sie nur die Buchung für den
                                            <span class="font-bold">{{ day | date }}</span> löschen, oder die gesamte Serie ab Heute?</span>
                                        </template>
                                        <template v-slot:confirm>Buchung löschen</template>
                                        <template v-slot:cancel v-show="!isSameDay(schedule)">
                                            Serie löschen
                                        </template>
                                        <button-delete><i class="fa fa-trash"></i></button-delete>
                                    </confirm-dialog>
                                </td>
                            </tr>
                        </tailwind-table>
                    </accordion-item>
                </accordion>


            </div>

            <p class="p-4" v-show="schedules.length === 0">
                Keine Buchungen in diesem Monat gefunden.
            </p>
        </div>

    </div>
</template>

<script>
import ButtonSecondary from "../components/UI/ButtonSecondary";
import Headline from "../components/UI/Headline";
import Monthspicker from "../components/Monthspicker";
import TailwindTable from "../components/UI/TailwindTable";
import ConfirmDialog from "../components/UI/ConfirmDialog";
import ButtonDelete from "../components/UI/ButtonDelete";
import Loading from "../components/UI/Loading";
import Accordion from "../components/UI/Accordion";
import AccordionItem from "../components/UI/AccordionItem";
import DeskItem from "../components/DeskItem.vue";
import BookingRelease from "../components/BookingRelease.vue";
import format from "date-fns/format"
import FloorItem from "../components/FloorItem.vue";

export default {
    name: "SchedulesPage",
    components: {
        FloorItem,
        DeskItem,
        AccordionItem,
        Accordion,
        Loading,
        ButtonDelete,
        ConfirmDialog,
        TailwindTable,
        Monthspicker,
        Headline,
        ButtonSecondary,
        BookingRelease,
    },

    data: () => ({
        loading: false,
        current: '',
        schedules: [],
        reservation: {},
        users: {},
        previous: '',
        next: '',
        releases: [],
        today: new Date().toISOString().substring(0, 10),
    }),

    mounted() {
        this.load();
    },

    filters: {
        date(date) {
            const [y, m, d] = date.split('-');

            return d + '.' + m + '.';
        },
    },
    methods: {
        isSameDay(schedule) {
            return schedule.reservation.from === schedule.reservation.to;
        },
        download() {
            window.open('/admin/schedules/export?month=' + this.current);
        },
        downloadAttendances() {
            window.open('/admin/schedules/export_attendances/?month=' + this.current);
        },
        load(date = null) {
            this.loading = true;
            window.axios.get(`/admin/schedules${date ? '?date=' + date : ''}`)
                .then(result => {
                    this.loading = false;
                    this.schedules = result.data.schedules;
                    this.users = result.data.users;
                    this.current = result.data.current;
                    this.next = result.data.next;
                    this.previous = result.data.previous;
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                })
        },

        remove(schedule, deleteSeries = false) {
            this.loading = true;
            this.$http.delete(`/admin/schedules/${schedule.id}`, {
                    params: {
                        deleteSeries: deleteSeries
                    }
                }
            )
                .then(() => {
                    this.loading = false;
                    this.load(this.current);
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                })
        },

        asDay(day) {
            return format(new Date(day), 'dd.MM.');
        },
    },
}
</script>

<style scoped>

</style>
